import { Component } from '@angular/core';
import { LanguageService } from '@core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';

@Component({
	selector: 'sf-app',
	template: '<router-outlet></router-outlet><tour-step-template></tour-step-template>',
})
export class AppComponent {
	constructor(
		private readonly languageService: LanguageService,
		private readonly translateService: TranslateService
	) {
		this.languageService.currentLanguage$.pipe(tap((value) => this.translateService.use(value))).subscribe();
	}
}
